import { render, staticRenderFns } from "./Comdac.vue?vue&type=template&id=5e6f83f1&"
import script from "./Comdac.vue?vue&type=script&lang=js&"
export * from "./Comdac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports